

export const isNoCssPrintView = () => {
    return window.location.href.indexOf("styles=false") > -1
}
